var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.options && _vm.options.length
    ? _c(
        "div",
        {
          directives: [
            {
              name: "on-clickaway",
              rawName: "v-on-clickaway",
              value: _vm.onClickAway,
              expression: "onClickAway"
            }
          ],
          staticClass: "single-select",
          class: { "menu-open": !!_vm.showOptions },
          on: { click: _vm.dropMenu }
        },
        [
          _c("div", { staticClass: "single-select__force-width" }, [
            _vm._v("\n    " + _vm._s(_vm.longestOption) + "\n  ")
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "shadow full-width",
              class: { "menu-open mdc-elevation--z8": !!_vm.showOptions }
            },
            [
              _c("div", { staticClass: "chosen-value-wrap full-width" }, [
                _c("div", { staticClass: "chosen-value full-width" }, [
                  _vm._v("\n        " + _vm._s(_vm.displayChosen) + "\n      ")
                ])
              ]),
              _vm._v(" "),
              _vm.showOptions
                ? _c(
                    "div",
                    {
                      staticClass: "dropdown options full-width",
                      attrs: { level: 8 }
                    },
                    _vm._l(_vm.optionsDisplay, function(option) {
                      return _c(
                        "div",
                        {
                          key: option.value,
                          staticClass: "option full-width",
                          attrs: { value: option.value },
                          on: {
                            click: function($event) {
                              return _vm.handleChoice(option.value)
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n        " + _vm._s(option.display) + "\n      "
                          )
                        ]
                      )
                    }),
                    0
                  )
                : _vm._e()
            ]
          )
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }